import { http, HttpResponse } from 'msw';

import { ONLINE_ENDPOINTS } from '@/config/api';
import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { SubmitLogbookRequest, SubmitLogbookResponse } from '../types';

// Format date to "DD MMM YYYY" format (date only, no time)
const formatLogbookDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

// API function
export const submitLogbook = (
  attemptId: string
): Promise<SubmitLogbookResponse> => {
  return axios.post(ONLINE_ENDPOINTS.USER.LOGBOOKS_SUBMIT, {
    attempt_id: attemptId,
  } as SubmitLogbookRequest);
};

// Mock handler
export const submitLogbookMockHandler = http.post(
  `${env.API_URL}${ONLINE_ENDPOINTS.USER.LOGBOOKS_SUBMIT}`,
  async ({ request }): Promise<HttpResponse<SubmitLogbookResponse>> => {
    await networkDelay();

    const body = (await request.json()) as SubmitLogbookRequest;

    const mockResponse: SubmitLogbookResponse = {
      status: 'Success',
      message: 'Logbook submitted successfully',
      attempt_id: body.attempt_id,
      attempt_status: 'SUBMITTED',
      submitted_at: formatLogbookDate(new Date()),
    };

    return HttpResponse.json(mockResponse);
  }
);
